import SmoothScroll from "smooth-scroll"
import tippy from "tippy.js"

import "./components/header"
import "./components/footer"
import "./components/verhalen-kennis-slider"
import "./components/logo-slider"
import "./components/accordion"
import "./components/faq-accordion"
import "./components/video-with-title"
import "./components/banner-image-new-title"

new SmoothScroll('a[href^="#"]', {
    speed: 300,
    offset: function () {
        return 100
    },
    easing: "Linear",
    ignore: 'a[href^="#openChat"]',
    topOnEmptyHash: false,
})

document.querySelectorAll('a[href^="#openChat"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault()
        console.log("Opening Tawk.to")
        if (window.Tawk_API) {
            window.Tawk_API.maximize()
        }
    })
})

document.querySelectorAll("[data-tooltip]").forEach((tooltip) => {
    tippy(tooltip, {
        content: tooltip.getAttribute("data-tooltip"),
        interactive: true,
        trigger: "click",
    })
})
